<template>
  <div class="layout-padding">
    <template v-if="items.length || isSearchResult">
      <div class="round-borders no-scroll">
        <q-toolbar color="white" class="justify-between">
          <div class="col">
            <q-search v-model="filter" class="q-mr-lg no-shadow" color="white" inverted-light clearable/>
          </div>

          <div class="col-auto">
            <template v-if="selectedItems.length">
              <q-btn icon="more_vert" class="items-toolbar__actions" color="grey-9" flat round dense>
                <q-popover>
                  <q-list link class="no-border">
                    <q-item v-if="selectedItems.length === 1" @click.native="handleEdit(null)" v-close-overlay>
                      <q-item-side icon="edit"/>
                      <q-item-main :label="$t('edit')"/>
                    </q-item>

                    <q-item @click.native="handleRemove(null)" v-close-overlay>
                      <q-item-side icon="delete"/>
                      <q-item-main :label="$t('remove')"/>
                    </q-item>
                  </q-list>
                </q-popover>
              </q-btn>
            </template>
          </div>
        </q-toolbar>
        <q-table
          :data="mappedItems"
          :columns="columns"
          :filter="filter"
          :selection="user.isUserOfActiveTeam() ? 'multiple' : 'none'"
          :selected.sync="selectedItems"
          :rows-per-page-options="rowsPerPageOptions"
          row-key="id"
          :pagination.sync="pagination"
          :loading="!itemsLoaded"
          @request="handleRequest"
          table-class="items-table"
          class="bg-white no-shadow no-border-radius"
          binary-state-sort
        >
          <q-td slot="body-cell-actions" slot-scope="props" :props="props">
            <q-btn icon="more_vert" color="grey-7" flat round dense>
                <q-popover>
                  <q-list link class="no-border">
                    <q-item @click.native="handleEdit(props.row)" v-close-overlay>
                      <q-item-side icon="edit"/>
                      <q-item-main :label="$t('edit')"/>
                    </q-item>

                    <q-item @click.native="handleRemove(props.row)" v-close-overlay>
                      <q-item-side icon="delete"/>
                      <q-item-main :label="$t('remove')"/>
                    </q-item>
                  </q-list>
                </q-popover>
              </q-btn>
          </q-td>
        </q-table>
      </div>
    </template>

    <template v-else>
      <div class="row justify-center items-center col-grow q-pt-lg">
        <div class="text-center">
          <img src="~assets/emptystates/items_empty.svg" />

          <h6 class="q-my-md text-faded">{{ $t('items_empty') }}</h6>

          <q-btn @click="handleCreateItem" color="primary" class="q-mt-lg" outline v-is-user>
            {{ $t('add_item') }}
          </q-btn>
        </div>
      </div>
    </template>

    <add-items-modal ref="createModal" v-is-user/>
    <update-items-modal ref="updateModal" />
  </div>
</template>

<script>
  import { defaultColumns, defaultMapFunction } from 'components/Items/Table/defaults'
  import { mapActions, mapGetters } from 'vuex'
  import AddItemsModal from 'components/Items/AddItemsModal.vue'
  import UpdateItemsModal from 'components/Items/UpdateItemsModal.vue'
  import { createErrorFromResponse } from 'src/utils/error'
  import store from 'src/store'
  import { tables } from 'src/config'

  export default {
    data () {
      return {
        columns: defaultColumns,
        selectedItems: [],
        pagination: {
          page: 1,
          rowsNumber: 0,
          rowsPerPage: 15,
          descending: false,
          sortBy: 'item_name'
        },
        filter: '',
        rowsPerPageOptions: tables.default_rows_per_page_options,
        isSearchResult: false
      }
    },

    computed: {
      ...mapGetters(['items', 'itemsMeta', 'itemsLoaded', 'user']),

      mappedItems () {
        return defaultMapFunction(this.items)
      },

      requestMethod () {
        if (this.filter && this.filter !== '') {
          return this.searchItems
        } else {
          return this.listItems
        }
      }
    },

    methods: {
      ...mapActions(['listItems', 'searchItems', 'deleteItems', 'fetchSelectedItem']),

      handleRequest ({ pagination, filter }) {
        this.requestMethod({ pagination, filter })
          .then(({ meta }) => {
            this.pagination = pagination
            this.pagination.rowsNumber = meta.pagination.total

            this.isSearchResult = filter && filter !== ''
          })
      },

      handleRemove (item = null) {
        const subjects = item ? [item] : this.selectedItems

        this.$q.dialog({
          title: this.$tc('confirm_checked_items_delete_title', 1),
          message: this.$tc('confirm_checked_items_delete_body', 1),
          ok: this.$t('confirm'),
          cancel: this.$t('abort')
        })
          .then(() => this.deleteItems(subjects))
          .then(({ meta }) => {
            this.pagination.rowsNumber = meta.pagination.total
          })
          .then(() => { this.selectedItems = [] })
          .catch(createErrorFromResponse)
      },

      handleEdit (item = null) {
        const subject = item || this.selectedItems[0]

        this.$refs.updateModal.open(subject.id)
      },

      handleCreateItem () {
        this.$refs.createModal.open()
      }
    },

    beforeRouteEnter (to, from, next) {
      store.dispatch('listItems')
        .then(({ meta }) => {
          next(vm => {
            vm.pagination.rowsNumber = meta.pagination.total
          })
        })
    },

    components: {
      AddItemsModal,
      UpdateItemsModal
    }
  }
</script>
